import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDTitleText } from '@facet-wealth/design';
import ScenarioSelectionAssumptionSections from './ScenarioSelectionAssumptionSections/ScenarioSelectionAssumptionSections';

const ScenarioSelectionAssumptionsMetaOverride = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDTitleText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('sections', {
    _component: () => ScenarioSelectionAssumptionSections,
  }, overrideReadOnly);


export default ScenarioSelectionAssumptionsMetaOverride;
